import { FC } from 'react';
import { useTrans } from 'base/utils/i18n';
import { TransparentModal } from '@pro/lib/TransparentModal';
import { IReward } from '@pro/common/EggHunt/interface';
import { RewardPoints } from '@base/lib/TransparentModal/RewardPoints';
import { RewardGuide } from '@base/lib/TransparentModal/RewardGuide';
import { RewardProduct } from '@base/lib/TransparentModal/RewardProduct';
import { RouteEnum } from 'pro/config/routers';

type IRewardPopupProps = {
    open: boolean;
    onCancel: () => void;
    reward: IReward;
};

export const RewardPopup: FC<IRewardPopupProps> = props => {
    const { open, onCancel, reward } = props;
    const { t } = useTrans();

    const isPoints = reward.type === 'points';
    const isLast = reward.remainingChances === 0;

    return (
        <TransparentModal
            title={t('web_common_congratulations')}
            open={open}
            onCancel={onCancel}
            okButtonProps={{
                text: isPoints ? t('web_common_btn_view_points') : t('web_cart_view_cart'),
                href: isPoints ? RouteEnum.POINTS : RouteEnum.CART,
            }}
            cancelButtonProps={{
                text: isLast ? t('web_common_btn_close') : t('web_eggs_keep_hunting'),
            }}
        >
            {isPoints ? (
                <>
                    <RewardPoints num={reward.points}/>
                    <RewardGuide>
                        <p>{t('web_eggs_points_added')}</p>
                        {isLast && <p>{t('web_eggs_reached_maximum_chances')}</p>}
                    </RewardGuide>
                </>
            ) : (
                <>
                    <RewardProduct product={reward.variant}/>
                    <RewardGuide>
                        <p>{t('web_eggs_product_added')}</p>
                        {isLast && <p>{t('web_eggs_reached_maximum_chances')}</p>}
                    </RewardGuide>
                </>
            )}
        </TransparentModal>
    )
};
